"use client";

import { cn } from "@/lib/utils";

const LETTERS = "abcçdefghijklmnoöprsştuüvyz".split("");

interface SearchLettersProps {
  activeLetter?: string;
  onSelectLetter: (letter: string) => void;
}

export default function SearchLetters({
  activeLetter = "",
  onSelectLetter,
}: SearchLettersProps) {
  return (
    <div className="w-full overflow-x-auto py-1 scrollbar-hide">
      <div className="flex flex-row border border-neutral-200 divide-neutral-200 divide-x rounded-lg overflow-hidden min-w-150 md:min-w-full bg-white">
        {LETTERS.map((letter) => {
          const isSelected =
            activeLetter.toLowerCase() === letter.toLowerCase();
          return (
            <button
              className={cn(
                "flex-1 py-1.5 text-center uppercase text-xs font-semibold transition-colors cursor-pointer",
                isSelected
                  ? "bg-brand-blue-600 text-white hover:bg-brand-blue-700"
                  : "text-neutral-700 hover:bg-brand-blue-50",
              )}
              key={letter}
              onClick={() => onSelectLetter(isSelected ? "" : letter)}
              type="button"
            >
              {letter}
            </button>
          );
        })}
      </div>
    </div>
  );
}
